import {
	Card,
	Col,
	Flex,
	Image,
	Row,
	Modal,
	Tabs,
	Typography,
	Button,
	Table,
} from 'antd';
import Header from '../../../components/Header/index.tsx';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import {
	useGetBaseJawsQuery,
	useGetJawAssembliesQuery,
} from '../../../redux/api/versabuilt.ts';
import {
	BaseJaw,
	JawAssembly,
	JawAssemblyConfiguration,
} from '../../../interfaces/VersaBuilt.Interface.ts';
import { ColumnsType } from 'antd/es/table/InternalTable';
import Fusion360Button from '../../../components/Fusion360Button/index.tsx';

interface IQueryParams {
	page?: number;
	ordering?: string;
	availability_status?: string;
	vendors?: string;
	shape?: string;
	types?: string;
}

interface AssemblyDetailsModalProps {
	visible: boolean;
	assembly: JawAssembly | null;
	onCancel: () => void;
}

const AssemblyDetailsModal = ({
	visible,
	assembly,
	onCancel,
}: AssemblyDetailsModalProps) => {
	// State for controlling the preview of the overlay image.
	const [previewVisible, setPreviewVisible] = useState(false);
	const [previewImage, setPreviewImage] = useState<string | null>();

	// Within your AssemblyDetailsModal component body, before the columns definition:
	// const configurationData = assembly?.configurations || [];

	// const uniqueStockShapeFilters = Array.from(
	// 	new Set(
	// 		configurationData
	// 			.map((item) => item.stock_shape)
	// 			.filter((s) => s !== undefined) as ('Rectangle Stock' | 'Round Stock')[]
	// 	)
	// ).map((value) => ({
	// 	text: value,
	// 	value,
	// }));

	// const uniqueStockWidthFilters = Array.from(
	// 	new Set(
	// 		configurationData
	// 			.map((item) => item.stock_width)
	// 			.filter((x): x is number => x !== null && x !== undefined)
	// 	)
	// )
	// 	.sort((a, b) => a - b)
	// 	.map((value) => ({
	// 		text: `${value} in`,
	// 		value,
	// 	}));

	// const uniqueStockMinLengthFilters = Array.from(
	// 	new Set(
	// 		configurationData
	// 			.map((item) => item.stock_min_length)
	// 			.filter((x): x is number => x !== null && x !== undefined)
	// 	)
	// )
	// 	.sort((a, b) => a - b)
	// 	.map((value) => ({
	// 		text: `${value} in`,
	// 		value,
	// 	}));

	// const uniqueStockDiameterFilters = Array.from(
	// 	new Set(
	// 		configurationData
	// 			.map((item) => item.stock_diameter)
	// 			.filter((s): s is number => s !== undefined && s !== null)
	// 	)
	// ).map((value) => ({
	// 	text: value.toString(), // converting number to string for display
	// 	value,
	// }));

	// Updated columns definition:
	const columns: ColumnsType<JawAssemblyConfiguration> = [
		{
			title: 'Thumbnail',
			key: 'thumbnail',
			render: (record: JawAssemblyConfiguration) => (
				<Image
					alt={record.name}
					src={record.thumbnail}
					height={128}
					width={128}
				/>
			),
		},
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Stock Shape',
			dataIndex: 'stock_shape',
			key: 'stock_shape',
			sorter: (a: JawAssemblyConfiguration, b: JawAssemblyConfiguration) =>
				(a.stock_shape || '').localeCompare(b.stock_shape || ''),
			// filters: uniqueStockShapeFilters,
			// onFilter: (
			// 	value: string | number | boolean,
			// 	record: JawAssemblyConfiguration
			// ) => record.stock_shape === value,
		},
		{
			title: 'Stock Width',
			dataIndex: 'stock_width',
			key: 'stock_width',
			render: (text: number) => (text ? `${text} in.` : null),
			sorter: (a: JawAssemblyConfiguration, b: JawAssemblyConfiguration) =>
				(a.stock_width || 0) - (b.stock_width || 0),
			// filters: uniqueStockWidthFilters,
			// onFilter: (
			// 	value: string | number | boolean,
			// 	record: JawAssemblyConfiguration
			// ) => record.stock_width === value,
		},
		{
			title: 'Top Jaw Height',
			key: 'top_jaw_height',
			render: (record: JawAssemblyConfiguration) =>
				record.top_jaw_set ? `${record.top_jaw_set.height} in.` : null,
		},
		{
			title: 'Min. Stock Length',
			dataIndex: 'stock_min_length',
			key: 'stock_min_length',
			render: (text: number) => (text ? `${text} in.` : null),
			sorter: (a: JawAssemblyConfiguration, b: JawAssemblyConfiguration) =>
				(a.stock_min_length || 0) - (b.stock_min_length || 0),
			// filters: uniqueStockMinLengthFilters,
			// onFilter: (
			// 	value: string | number | boolean,
			// 	record: JawAssemblyConfiguration
			// ) => record.stock_min_length === value,
		},
		{
			title: 'Stock Diameter',
			dataIndex: 'stock_diameter',
			key: 'stock_diameter',
			render: (text: number) => (text ? `${text} in.` : null),
			sorter: (a: JawAssemblyConfiguration, b: JawAssemblyConfiguration) =>
				(a.stock_diameter || 0) - (b.stock_diameter || 0),
			// filters: uniqueStockDiameterFilters,
			// onFilter: (
			// 	value: string | number | boolean,
			// 	record: JawAssemblyConfiguration
			// ) => record.stock_diameter === value,
		},
		{
			title: 'Overlay',
			key: 'wireframe_overlay',
			render: (record: JawAssemblyConfiguration) =>
				record.wireframe_overlay ? (
					<Button
						type="link"
						onClick={() => {
							setPreviewImage(record.wireframe_overlay);
							setPreviewVisible(true);
						}}
					>
						View Overlay
					</Button>
				) : null,
		},
	];

	return (
		<Modal
			open={visible}
			title={
				<div className="flex flex-col mb-3">
					<Typography.Title level={4} className="mb-0">
						{assembly?.name}
					</Typography.Title>
				</div>
			}
			onCancel={onCancel}
			footer={null}
			destroyOnClose={true}
			width={1440}
			styles={{
				body: {
					maxHeight: 'calc(100vh - 300px)',
					overflowY: 'auto',
				},
			}}
		>
			<Tabs
				defaultActiveKey="details"
				items={[
					{
						key: 'details',
						label: `Details`,
						children: (
							<div className="flex flex-row gap-10">
								<Image
									alt={assembly?.name}
									src={assembly?.thumbnail}
									style={{ maxHeight: '360px' }}
									className="border"
								/>
								<div className="flex flex-col items-start gap-3">
									{assembly?.modular_component_family ? (
										<div className="flex flex-col items-start">
											<Typography.Text strong>Modular Family:</Typography.Text>
											<Typography.Text>
												{assembly?.modular_component_family?.name}
											</Typography.Text>
										</div>
									) : null}

									{assembly?.top_jaw_family ? (
										<div className="flex flex-col items-start">
											<Typography.Text strong>Top Jaw Family:</Typography.Text>
											<Typography.Text>
												{assembly?.top_jaw_family?.name}
											</Typography.Text>
										</div>
									) : null}

									{assembly?.fusion_360_id ? (
										<Fusion360Button fusionURN={assembly?.fusion_360_id} />
									) : null}
								</div>
							</div>
						),
					},
					{
						key: 'configurations',
						label: `Configurations (${assembly?.configurations?.length})`,
						children: (
							<>
								<Table
									dataSource={assembly?.configurations || []}
									columns={columns}
									rowKey="id"
									pagination={false}
									scroll={{ x: '1280px' }}
								/>
							</>
						),
					},
				]}
			/>

			{/* Controlled antd Image component for previewing overlay */}
			<Image
				src={previewImage || ''}
				style={{ display: 'none' }}
				preview={{
					visible: previewVisible,
					onVisibleChange: (vis) => setPreviewVisible(vis),
				}}
			/>
		</Modal>
	);
};

function MultiGripWorkholding() {
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const currentPageUrl = Number(queryParams.get('page')) || 1;
	const ordering = queryParams.get('ordering') || '';

	const query: IQueryParams = {};

	if (currentPageUrl) {
		query.page = currentPageUrl;
	}

	if (ordering && ordering !== '') {
		query.ordering = ordering;
	}

	const getBaseJaws = useGetBaseJawsQuery();
	const getJawAssemblies = useGetJawAssembliesQuery();

	// State for modal visibility and selected assembly
	const [configModalVisible, setConfigModalVisible] = useState(false);
	const [selectedAssembly, setSelectedAssembly] = useState<JawAssembly | null>(
		null
	);

	// Handle card click to display the configurations modal
	const handleAssemblyClick = (assembly: JawAssembly) => {
		setSelectedAssembly(assembly);
		setConfigModalVisible(true);
	};

	const tabs = [
		{
			key: 'assemblies',
			label: 'Jaw Assemblies',
			children: (
				<div className="bg-white border-r border-l border-b w-full p-5">
					<Row justify="start" gutter={[16, 16]}>
						{getJawAssemblies?.data?.map((assembly: JawAssembly) => (
							<Col key={assembly.id} span={24} sm={24} xl={12}>
								<Card className="h-full">
									<div className="h-full flex flex-row gap-10">
										<Image
											alt={assembly.name}
											src={assembly?.thumbnail}
											style={{ maxHeight: '128px' }}
											preview={false}
										/>
										<div className="flex flex-col items-start">
											<div className="flex flex-col items-start mb-2">
												<Typography.Title level={5} style={{ marginBottom: 0 }}>
													{assembly.name}
												</Typography.Title>

												{assembly?.description ? (
													<Typography.Text>
														{assembly?.description}
													</Typography.Text>
												) : null}

												<Typography.Text type="secondary" className="mb-2">
													{`${assembly.configurations?.length || 0} ${
														assembly.configurations?.length === 1
															? 'Configuration'
															: 'Configurations'
													}`}
												</Typography.Text>
											</div>

											<div className="flex flex-row gap-2 mb-1">
												<Button
													type="primary"
													onClick={() => handleAssemblyClick(assembly)}
												>
													Details
												</Button>

												<Fusion360Button fusionURN={assembly?.fusion_360_id} />
											</div>
										</div>
									</div>
								</Card>
							</Col>
						))}
					</Row>
				</div>
			),
		},
		{
			key: 'basejaws',
			label: 'Base Jaws',
			children: (
				<div className="bg-white border-r border-l border-b w-full p-5">
					<Row justify="start" gutter={[16, 16]}>
						{getBaseJaws?.data?.map((baseJaw: BaseJaw) => (
							<Col key={baseJaw.id} span={24} sm={24} xl={12}>
								<Card>
									<div className="h-full flex flex-row gap-10">
										<Image
											alt={baseJaw.name}
											src={baseJaw?.thumbnail}
											style={{ maxHeight: '128px' }}
										/>
										<div className="flex flex-col">
											<Typography.Title level={5}>
												{baseJaw.name}
											</Typography.Title>

											<Typography.Text type="secondary">
												{`${baseJaw?.clamping_type} Clamping`}
											</Typography.Text>
											<Typography.Text type="secondary">
												{baseJaw?.description}
											</Typography.Text>

											{baseJaw?.fusion_360_id ? (
												<Fusion360Button fusionURN={baseJaw?.fusion_360_id} />
											) : null}
										</div>
									</div>
								</Card>
							</Col>
						))}
					</Row>
				</div>
			),
		},
	];

	return (
		<>
			<Flex justify="space-between" align="center">
				<Header
					title="MultiGrip Workholding"
					breadcrumbItems={[
						{
							title: 'Workholding',
						},
						{
							title: 'MultiGrip',
						},
					]}
				/>
			</Flex>

			<div className="flex flex-row gap-2 items-start mb-5">
				<Tabs
					defaultActiveKey="assemblies"
					items={tabs}
					size="small"
					type="card"
					tabBarStyle={{ marginBottom: 0 }}
					className="w-full"
				/>
			</div>

			<AssemblyDetailsModal
				visible={configModalVisible}
				assembly={selectedAssembly}
				onCancel={() => setConfigModalVisible(false)}
			/>
		</>
	);
}

export default MultiGripWorkholding;
